function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base/index';
import { uiSizeType } from '../base/types';
import { filterCopy } from '../utils';
import './style.less';

var Input = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Input, _KZUIComponent);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _this.autoBind('handleChange', 'handleKeyPress', 'handleBlur', 'toFocus');

    if (props.uncontroled) {
      _this.state = {
        value: props.value
      };
    }

    return _this;
  }

  _createClass(Input, [{
    key: "toFocus",
    value: function toFocus() {
      this.textInput.focus();
    }
  }, {
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      if (props.uncontroled) return undefined;
      return {
        value: props.value
      };
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      if (this.props.onBlur) {
        this.props.onBlur({
          value: event.target.value,
          name: this.props.name
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        value: event.target.value
      });

      if (this.props.onChange) {
        this.props.onChange({
          value: event.target.value,
          name: this.props.name
        });
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (this.props.onKeyPress) {
        this.props.onKeyPress(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var clsPrefix = 'kui-input';

      var _this$props = this.props,
          type = _this$props.type,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          error = _this$props.error,
          name = _this$props.name,
          size = _this$props.size,
          className = _this$props.className,
          maxLength = _this$props.maxLength,
          others = _objectWithoutProperties(_this$props, ["type", "disabled", "placeholder", "error", "name", "size", "className", "maxLength"]);

      var value = this.state.value;
      var finalError = error;

      if (maxLength) {
        if (value.length > maxLength) {
          finalError = true;
        }
      }

      var cls = classNames((_classNames = {}, _defineProperty(_classNames, clsPrefix, true), _defineProperty(_classNames, "".concat(clsPrefix, "__disabled"), !!disabled), _defineProperty(_classNames, "".concat(clsPrefix, "__error"), finalError), _defineProperty(_classNames, "".concat(clsPrefix, "__").concat(size), true), _classNames), className);
      var extraProps = filterCopy(others, 'uncontroled', 'onChange');

      if (maxLength) {
        var countCls = classNames("".concat(clsPrefix, "--count"), _defineProperty({}, "".concat(clsPrefix, "--count__error"), finalError));
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "--wrapper")
        }, /*#__PURE__*/React.createElement("input", _extends({}, extraProps, {
          className: cls,
          type: type,
          name: name,
          value: value,
          placeholder: placeholder,
          disabled: disabled,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyPress,
          ref: function ref(input) {
            _this2.textInput = input;
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: countCls
        }, value.length, "/", maxLength));
      }

      return /*#__PURE__*/React.createElement("input", _extends({}, extraProps, {
        className: cls,
        type: type,
        name: name,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyPress,
        ref: function ref(input) {
          _this2.textInput = input;
        }
      }));
    }
  }]);

  return Input;
}(KZUIComponent);

Input.defaultProps = {
  type: 'text',
  size: 'normal',
  disabled: false,
  error: false,
  name: '',
  placeholder: '',
  uncontroled: false,
  value: '',
  onBlur: null,
  onChange: null,
  onKeyPress: null,
  maxLength: null
};
Input.propTypes = {
  type: PropTypes.oneOf(['text', 'password']),
  size: uiSizeType,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  uncontroled: PropTypes.bool,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  maxLength: PropTypes.number
};
export default Input;